import styled from 'styled-components'
import { Card, TextButton } from '@amzn/storm-ui'
import { InternalLink } from '@amzn/aapn-react-components'

export const MainContainer = styled.div`
  width: 100%;
`
export const FocusViewContainer = styled.div`
  display: flex;
  justify-content: space-between;
  min-height: 100px;
  z-index: 10;
  position: relative;
  box-shadow: ${({ theme }) => theme.card.boxShadow};
`
export const PageTitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.large};
`
export const CloseButton = styled(TextButton)`
  color: ${({ theme }) => theme.palette.black};
  padding-inline-start: ${({ theme }) => theme.spacing.large};
`

export const ActionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.large};
`

export const HelpContainer = styled.span`
  margin-inline-end: ${({ theme }) => theme.spacing.large};
`

export const StyledLink = styled(InternalLink)`
  height: 100%;
  color: ${({ theme }) => theme.palette.squidInk}  !important;
  padding: 0 ${({ theme }) => theme.spacing.small};
  :hover {
    background-color: ${({ theme }) => theme.palette.squidInk};
  }
  font-size: ${({ theme }) => theme.typography.size.large}});
`
export const CardContainer = styled.div`
  width: 100%;
  padding-top: ${({ theme }) => theme.spacing.xlarge};
  margin: auto;
`

export const ContentContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.concrete};
  height: 100%;
`

export const StyledCard = styled(Card)`
  width: 50%;
  margin: auto;
`
